import { API_URL as ENDPOINT } from "../config/env";

export async function ClienteGet(token) {
  return fetch(`${ENDPOINT}ClientesGet`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "get",
  })
    .then((res) => res.json())
    .then((response) => {
      return response;
    });
}

export async function ClienteAdd(data, token) {
  return fetch(`${ENDPOINT}ClientesAdd`, {
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "post",
    body: data,
  })
    .then((res) => res.json())
    .then((response) => {
      return response;
    });
}

export async function ClienteUpdate(data, token) {
  return fetch(`${ENDPOINT}ClientesUpdate`, {
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "post",
    body: data,
  })
    .then((res) => res.json())
    .then((response) => {
      return response;
    });
}

export async function ClienteDelete(data, token) {
  return fetch(`${ENDPOINT}ClientesDelete`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
    method: "post",
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((response) => {
      return response;
    });
}
